var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneHundred(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4354 15.7539C17.2118 16.2578 15.4425 14.8464 15.1543 11.4393C14.8798 8.02838 16.3752 5.92525 18.5988 5.42136C20.7988 4.93884 22.6053 6.32505 22.8897 9.71843C23.1681 13.1431 21.6354 15.2714 19.4354 15.7539ZM19.2982 14.0485C20.5234 13.7795 21.1015 12.4651 20.9128 10.1533C20.728 7.85523 19.9613 6.85791 18.7398 7.14053C17.4597 7.42479 16.9327 8.7102 17.1175 11.0083C17.3062 13.3201 18.0356 14.3426 19.2982 14.0485Z",
    fill: "#C7B9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8851 18.1453C8.66154 18.6492 6.89224 17.2378 6.60403 13.8307C6.32953 10.4197 7.82488 8.31661 10.0485 7.81272C12.2485 7.3302 14.055 8.7164 14.3394 12.1098C14.6178 15.5344 13.0851 17.6628 10.8851 18.1453ZM10.7479 16.4398C11.9731 16.1709 12.5512 14.8564 12.3625 12.5447C12.1777 10.2466 11.411 9.24926 10.1896 9.53189C8.90946 9.81614 8.38238 11.1016 8.56721 13.3996C8.75587 15.7114 9.48531 16.7339 10.7479 16.4398Z",
    fill: "#C7B9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.949145 11.4529L3.78531 9.7579L5.16958 9.37061L5.9652 19.3452L4.0464 19.882L3.40387 11.9336L1.08746 13.3206L0.949145 11.4529Z",
    fill: "#C7B9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4961 2.83069C21.59 3.18254 21.3841 3.54501 21.0363 3.64027L1.72613 8.92942C1.37831 9.02468 1.02029 8.81668 0.926452 8.46483C0.832619 8.11298 1.03851 7.75052 1.38632 7.65525L20.6965 2.36611C21.0443 2.27084 21.4023 2.47884 21.4961 2.83069Z",
    fill: "#9488F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3711 16.5352C23.465 16.887 23.2591 17.2495 22.9113 17.3447L3.60113 22.6339C3.25331 22.7292 2.89529 22.5212 2.80145 22.1693C2.70762 21.8175 2.91351 21.455 3.26132 21.3597L22.5715 16.0706C22.9193 15.9753 23.2773 16.1833 23.3711 16.5352Z",
    fill: "#9488F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneHundred);
export default __webpack_public_path__ + "static/media/one-hundred.4c25c6420dc358e295972c1fe6057bab.svg";
export { ForwardRef as ReactComponent };